export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.one-click-fall-alert': '一键跌倒告警测试',
  'menu.tencent-lbs-network-location': '腾讯地图硬件定位测试',
  'menu.platform': '平台管理',
  'menu.platform.companies': '公司管理',
  'menu.platform.mini-programs': '小程序管理',
  'menu.platform.tencent-lbs-configs': '腾讯地图配置管理',
  'menu.platform.simulator': '模拟自测',
  'menu.platform.simulator.mqtt': '模拟硬件设备',
  'menu.region': '区域管理',
  'menu.region.devices': '设备管理',
  'menu.region.alerts': '跌倒记录查询',
  'menu.region.telemetry': '日常数据查询',
  'menu.region.device-wills': '状态历史数据查询',
  'menu.region.notifications': '通知记录查询',
  'menu.region.notification-channels': '通知渠道配置',
  'menu.miniprogram': '微信小程序管理',
  'menu.miniprogram.dashboard': '仪表盘',
  'menu.miniprogram.users': '用户管理',
  'menu.miniprogram.regions': '区域管理',
  'menu.miniprogram.devices': '设备管理',
  'menu.miniprogram.wearers': '佩戴人管理',
  'menu.miniprogram.alerts': '跌倒记录查询',
  'menu.miniprogram.telemetry': '日常数据查询',
  'menu.miniprogram.device-wills': '状态历史数据查询',
  'menu.miniprogram.notifications': '通知记录查询',
  'menu.miniprogram.notification-channels': '通知渠道配置',
  'menu.miniprogram.simulator': '模拟自测',
  'menu.miniprogram.simulator.mqtt': '模拟硬件设备',
  'menu.emqx': 'EMQX管理',
  'menu.emqx.users': '用户管理',
  'menu.emqx.acl': 'ACL管理',
  'menu.hardware': '硬件程序管理',
  'menu.hardware.fall-guard': '跌倒防摔服',
  'menu.system': '系统管理',
  'menu.system.login-settings': '登录管理',
  'menu.system.operation-logs': '操作日志',
  'menu.examples': '开发参考示例',
  'menu.examples.dashboard': '测试-Dashboard',
  'menu.examples.dashboard.analysis': '测试-分析页',
  'menu.examples.dashboard.monitor': '测试-监控页',
  'menu.examples.dashboard.workplace': '测试-工作台',
  'menu.examples.form': '测试-表单页',
  'menu.examples.form.basic-form': '测试-基础表单',
  'menu.examples.form.step-form': '测试-分步表单',
  'menu.examples.form.step-form.info': '测试-分步表单（填写转账信息）',
  'menu.examples.form.step-form.confirm': '测试-分步表单（确认转账信息）',
  'menu.examples.form.step-form.result': '测试-分步表单（完成）',
  'menu.examples.form.advanced-form': '测试-高级表单',
  'menu.examples.list': '测试-列表页',
  'menu.examples.list.table-list': '测试-查询表格',
  'menu.examples.list.basic-list': '测试-标准列表',
  'menu.examples.list.card-list': '测试-卡片列表',
  'menu.examples.list.search-list': '测试-搜索列表',
  'menu.examples.list.search-list.articles': '测试-搜索列表（文章）',
  'menu.examples.list.search-list.projects': '测试-搜索列表（项目）',
  'menu.examples.list.search-list.applications': '测试-搜索列表（应用）',
  'menu.examples.profile': '测试-详情页',
  'menu.examples.profile.basic': '测试-基础详情页',
  'menu.examples.profile.advanced': '测试-高级详情页',
  'menu.examples.result': '测试-结果页',
  'menu.examples.result.success': '测试-成功页',
  'menu.examples.result.fail': '测试-失败页',
  'menu.examples.exception': '测试-异常页',
  'menu.examples.exception.403': '403',
  'menu.examples.exception.404': '404',
  'menu.examples.exception.500': '500',
  'menu.examples.exception.not-permission': '403',
  'menu.examples.exception.not-find': '404',
  'menu.examples.exception.server-error': '500',
  'menu.examples.exception.trigger': '测试-触发错误',
  'menu.examples.account': '测试-个人页',
  'menu.examples.account.center': '测试-个人中心',
  'menu.examples.account.settings': '测试-个人设置',
  'menu.examples.account.trigger': '测试-触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '测试-图形编辑器',
  'menu.editor.flow': '测试-流程编辑器',
  'menu.editor.mind': '测试-脑图编辑器',
  'menu.editor.koni': '测试-拓扑编辑器',
};
